import { render, staticRenderFns } from "./data-source-setting.vue?vue&type=template&id=384d68f2&scoped=true&"
import script from "./data-source-setting.vue?vue&type=script&lang=js&"
export * from "./data-source-setting.vue?vue&type=script&lang=js&"
import style0 from "./data-source-setting.vue?vue&type=style&index=0&id=384d68f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d68f2",
  null
  
)

export default component.exports